/**
 * Presentation defaults, in one place.
 *
 * These were previously inline `?? 'medium'` / `!== false` / `?? 0` expressions
 * scattered through the presenter, which meant the defaults existed twice — here
 * and in `panelPresentationSchema`'s `.default(...)` calls in
 * `packages/db-types/src/panel-definition.ts` — with nothing keeping them equal.
 * `tests/architecture/panel-schema-mirror.test.ts` now pins this object against
 * `panelPresentationSchema.parse({})`, so a default changed on one side fails CI.
 */
import type { PanelPresentation } from './types';

export const DEFAULT_PANEL_PRESENTATION: Required<PanelPresentation> = {
  size: 'medium',
  dismissible: true,
  priority: 0,
};

/** Fill a partial presentation hint with the defaults above. */
export function resolvePanelPresentation(
  ...overrides: ReadonlyArray<PanelPresentation | undefined>
): Required<PanelPresentation> {
  const resolved = { ...DEFAULT_PANEL_PRESENTATION };
  for (const override of overrides) {
    if (!override) continue;
    if (override.size !== undefined) resolved.size = override.size;
    if (override.dismissible !== undefined) resolved.dismissible = override.dismissible;
    if (override.priority !== undefined) resolved.priority = override.priority;
  }
  return resolved;
}
